<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
         <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('app.filters.created_at_from_to')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.from')}}</label>
                        <el-form-item prop="fechaAltaDesde">
                          <el-date-picker class="bg-white dark:bg-darkblue-900"
                            v-model="form.fechaAltaDesde.value" type="date" :picker-options="dateRangeOptions"
                            :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                          </el-date-picker>
                        </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.to')}}</label>
                      <el-form-item prop="fechaAltaHasta">
                          <el-date-picker class="bg-white dark:bg-darkblue-900"
                            v-model="form.fechaAltaHasta.value" type="date" :picker-options="dateRangeOptions"
                            :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                          </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.cif')}}</label>
              <el-form-item prop="cif">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.cif.value"
                  maxlength="50"
                />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.companyName')}}</label>
              <el-form-item prop="name">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="255"
                />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.active_reports')}}</label>
              <el-form-item prop="ActiveReports">
                <base-el-select class="w-full" :options="avaliableReports" v-model="form.ActiveReports.value" multiple clearable />
              </el-form-item>
            </div>
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.send_alerts')}}</label>
              <el-form-item prop="send_alerts">
                <base-el-select class="w-full" :options="values" v-model="form.send_alerts.value" clearable :placeholder="$t('companies.send_alerts_yes_no')" />
              </el-form-item>
            </div>

            <!-- <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('grouping.entity_name')}}</label>
              <el-form-item prop="nombreAgrupacion">
                <base-el-select class="w-full" :options="listGrouping" v-model="form.nombreAgrupacion.value" :loading="loadingData" clearable filterable />
              </el-form-item>
            </div> -->

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.active')}}</label>
              <el-form-item prop="estado">
                <base-el-select class="w-full" :options="values" v-model="form.estado.value" clearable :placeholder="$t('companies.active_yes_no')" />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('grouping.entity_name')}}</label>
              <el-form-item prop="nombreAgrupacion">
                 <el-select class="w-full" v-model="form.nombreAgrupacion.value" clearable filterable :placeholder="$t('app.select')">
                    <el-option
                      v-for="(item, index) in listGrouping"
                      :key="index"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$tc('users.email', 1)}}</label>
              <el-form-item prop="email">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.email.value"
                  maxlength="500"
                />
              </el-form-item>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
import { i18n } from '@/i18n'
import { getAgrupacionesNombreCompanies } from '@/services/configurations/grouping/getAgrupacionesNombreCompanies'
import { getsistemasreportefiscal } from '@/services/companies/getsistemasreportefiscal'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
// import { mapGetters } from 'vuex'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'groupcompanies',
      isOpen: this.panelOpen,
      form: {
        cif: { label: i18n.t('companies.cif'), value: '' },
        name: { label: i18n.t('companies.companyName'), value: '' },
        send_alerts: { label: i18n.t('app.send_alerts'), value: '' },
        fechaAltaDesde: { label: i18n.t('app.filters.fecha_alta_from'), value: '' },
        fechaAltaHasta: { label: i18n.t('app.filters.fecha_alta_to'), value: '' },
        email: { label: i18n.tc('users.email', 1), value: '' },
        estado: { label: i18n.t('app.active'), value: '' },
        nombreAgrupacion: { label: i18n.t('grouping.entity_name'), value: '' },
        ActiveReports: { label: i18n.t('companies.active_reports'), value: '' },
      },
      listGrouping: [],
      avaliableReports: [],
      loadingData: false,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  mounted: async function () {
    const dataAgrupaciones = await getAgrupacionesNombreCompanies()
    if (dataAgrupaciones.blnError === true) {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataAgrupaciones))
    }
    this.listGrouping = dataAgrupaciones.Respuesta
    const dataReports = await getsistemasreportefiscal()
    if (dataReports.blnError === true) {
      this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataReports))
    }
    this.avaliableReports = []
    if (Array.isArray(dataReports.Respuesta)) {
      dataReports.Respuesta.forEach(reportId => this.avaliableReports.push(this.tiposReportingActivo.find(x => x.id === reportId) || { id: reportId }))
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    tiposReportingActivo: function () {
      return this.$store.getters['config/TIPOS_REPORTING_ACTIVO']
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.cif.value = _temp.cif !== undefined && _temp.cif.value !== '' ? _temp.cif.value : ''
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.send_alerts.value = _temp.send_alerts !== undefined && _temp.send_alerts.value !== '' ? _temp.send_alerts.value : ''
        this.form.fechaAltaDesde.value = _temp.fechaAltaDesde !== undefined && _temp.fechaAltaDesde.value !== '' ? _temp.fechaAltaDesde.value : ''
        this.form.fechaAltaHasta.value = _temp.fechaAltaHasta !== undefined && _temp.fechaAltaHasta.value !== '' ? _temp.fechaAltaHasta.value : ''
        this.form.estado.value = _temp.estado !== undefined && _temp.estado.value !== '' ? _temp.estado.value : ''
        this.form.email.value = _temp.email !== undefined && _temp.email.value !== '' ? _temp.email.value : ''
        this.form.nombreAgrupacion.value = _temp.nombreAgrupacion !== undefined && _temp.nombreAgrupacion.value !== '' ? _temp.nombreAgrupacion.value : ''
        this.form.ActiveReports.value = _temp.ActiveReports !== undefined && _temp.ActiveReports.value !== '' ? _temp.ActiveReports.value : ''
      }
    },
    watchFormHandler: function ({ send_alerts, estado }) {
      if (send_alerts !== undefined && send_alerts.value) {
        this.form.send_alerts.value = !!send_alerts.value
      }
      if (estado !== undefined && estado.value) {
        this.form.estado.value = !!estado.value
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        cif: { label: i18n.t('companies.cif'), value: '' },
        name: { label: i18n.t('companies.companyName'), value: '' },
        send_alerts: { label: i18n.t('app.send_alerts'), value: '' },
        fechaAltaDesde: { label: i18n.t('app.filters.fecha_alta_from'), value: '' },
        fechaAltaHasta: { label: i18n.t('app.filters.fecha_alta_to'), value: '' },
        estado: { label: i18n.t('app.active'), value: '' },
        email: { label: i18n.tc('users.email', 1), value: '' },
        nombreAgrupacion: { label: i18n.t('grouping.entity_name'), value: '' },
        ActiveReports: { label: i18n.t('companies.active_reports'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
